export const MARKETPLACE = {
  TH: {
    AVAILABLE_ON: 'Avaiable on',
    APP_STORE_AND_GOOGLE_PLAY: 'App store and Google play',
  },
  EN: {
    AVAILABLE_ON: 'Avaiable on',
    APP_STORE_AND_GOOGLE_PLAY: 'App store and Google play',
  }
}
